module.exports = {
  label: 'Lịch sử tệp',
  Details: 'Chi tiết thuộc tính',
  view: 'Xem tệp',
  PlsInput: 'Vui lòng nhập',
  Query: 'Tìm kiếm',
  fileName: 'Tên tệp',
  fileVersion: 'Phiên bản',
  jobType: 'Loại tệp',
  fileType: 'Định dạng tệp',
  fileSize: 'Kích thước tệp',
  createdBy: 'Người tạo',
  createdDate: 'Ngày tạo',
  tagName: 'Tên thuộc tính',
  tagValue: 'Giá trị thuộc tính',
  Tips: 'Thông báo',
  DownloadFile: 'Có lưu tệp không?',
  Succeed: 'Tải xuống thành công',
  Failed: 'Tải xuống thất bại',
  noFile: 'Không có lịch sử.',
  Refresh: 'Làm mới',
  Upload: 'Tải lên',
  Delete: 'Xóa',
  BatchDownload: 'Tải xuống hàng loạt',
  SendEmail: 'Gửi email',
  TransferAllToFileHistory: 'Chuyển tất cả vào lịch sử tệp',
  ingotUpload: 'Tải lên ingot',
  ingotLog: 'Nhật ký ingot',
  preview: 'Xem trước',
  synchronization: 'Đồng bộ',
  cancelSynchronization: 'Hủy đồng bộ',
  synchronizationState: 'Trạng thái đồng bộ',
  operation: 'Thao tác',
  fileDownload: 'Tải xuống tệp',
  ExternalFileType: 'Loại tệp bên ngoài',
  LastSyncTime: 'Thời gian đồng bộ cuối',
  DisplayTicketFile: 'Hiển thị tệp biên lai',
  SendDestinationPortAgent: 'Gửi đại lý cảng đích',
  SentDestinationPortAgent: 'Đã gửi đại lý cảng đích',
  ResetOneClickSend: 'Đặt lại gửi một lần',
  FileCreator: 'Người tạo tệp',
  FileCreationDate: 'Ngày tạo tệp',
  HasDeleted: 'Có xóa không?',
  SendSetOfProxyOrders: 'Gửi đại lý bộ đơn',
  ProxyName: 'Tên đại lý'
}
